import React from 'react';
import { CalendarDaysIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1012">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1013">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1014">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1015">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1016">
              <CalendarDaysIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1017" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1018">
              Monthly Classes
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1019">
              Scheduled year round on a monthly basis. Check the club calendar
              for current dates.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1020">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1021">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1022" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1023">
              10-Hour Course
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1024">
              Comprehensive classroom and range instruction over a full day.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1025">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1026">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1027" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1028">
              From $85
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1029">
              Members: $85 · Non-Members: $140. Tuition is non-refundable except
              for cancelled classes.
            </p>
          </div>
        </div>
      </div>
    </div>;
}